import React, { useCallback } from 'react';

import { LailaMessage } from '../../../../types';
import { ChatThread } from '../../../../components/Chat/kit';
import { LailaBubble } from './LailaBubble';
import { LailaTyping } from './LailaTyping';
import { lailaMeta } from './threadItems';

const isOwn = (message: LailaMessage) => message.role === 'user';

interface Props {
  messages: LailaMessage[];
  thinking: boolean;
  // What Laila is doing before her first words.
  status?: string;
  onRetry?: () => void;
  onStop?: () => void;
  // Shown instead of the thread while there are no messages.
  emptyState?: React.ReactNode;
  copyable?: boolean;
  className?: string;
}

// Laila's conversation on the shared chat thread.
export const LailaThread: React.FC<Props> = ({
  messages,
  thinking,
  status,
  onRetry,
  onStop,
  emptyState,
  copyable,
  className,
}) => {
  const renderMessage = useCallback(
    (message: LailaMessage, { first, last }: { first: boolean; last: boolean }) => (
      <LailaBubble message={message} first={first} last={last} copyable={copyable} onRetry={onRetry} />
    ),
    [copyable, onRetry]
  );

  return (
    <ChatThread
      className={className}
      messages={messages}
      meta={lailaMeta}
      isOwn={isOwn}
      renderMessage={renderMessage}
      emptyState={emptyState}
      // Dots until the answer's first words, which then show as they are written.
      typing={
        thinking && messages[messages.length - 1]?.role !== 'assistant' ? (
          <LailaTyping label={status} onStop={onStop} />
        ) : undefined
      }
    />
  );
};
